$(function () {
    $('.l-header__menu').click(function () {
        $(this).toggleClass('active');

        if ($(this).hasClass('active')) {
            $('.l-header__sp-nav').addClass('active');
        } else {
            $('.l-header__sp-nav').removeClass('active');
        }
    });

    $('.l-header__sp-nav ul li a').click(function () {
        $('.l-header__sp-nav').removeClass('active');
        $('.l-header__menu').toggleClass('active');
    });
});

$(function () {
    $('a[href^="#"]').click(function () {
        var speed = 500;
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top;
        $('html, body').animate({
            scrollTop: position
        }, speed, 'wing');
        return false;
    });
});
